import {HTH} from "../HTH";
import {HTHSound} from "../sound/HTHSound";
import {HTHGameConfig} from "../HTHGameConfig";

export interface IWinRatioConfig {
    readonly ratio: number;
    readonly duration: number;
    readonly type: string;
    sound: string
}

export interface IBigWinLevel extends IWinRatioConfig {
    readonly from: number;
    to: number;
    readonly id: number;
}

export interface INormalWinRatios {
    readonly normalWin: IWinRatioConfig[];
}
export interface IWinRatio {
    readonly normalWin: IWinRatioConfig[];
    readonly bigWin: IBigWinLevel[];
}
export interface IBigWinRatios {
    readonly bigWinBaseGame: IBigWinLevel[];
    readonly bigWinFreeSpin: IBigWinLevel[];
    readonly bigWinBonusBuy: IBigWinLevel[];
    readonly bigWinGodMode: IBigWinLevel[];
}

export class HTHWinConfig {

    public static TINY: string = "tiny";
    public static SMALL: string = "small";
    public static MEDIUM: string = "medium";
    public static LARGE: string = "large";
    public static BIG_WIN_01: string = "bigWin01";
    public static BIG_WIN_02: string = "bigWin02";
    public static BIG_WIN_03: string = "bigWin03";
    public static BIG_WIN_04: string = "bigWin04";
    public static BIG_WIN_05: string = "bigWin05";

    public static NORMAL_WIN_RATIOS: INormalWinRatios={
        normalWin: [
            {
                ratio: 0,
                duration: 0.001,
                type: HTHWinConfig.TINY,
                sound:HTHSound.COUNTUP_END_TINY
            },
            {
                ratio: 1.5,
                duration: 0.001,
                type: HTHWinConfig.SMALL,
                sound:HTHSound.COUNTUP_END_SMALL
            },
            {
                ratio: 3,
                duration: 0.5,
                type: HTHWinConfig.MEDIUM,
                sound:HTHSound.COUNTUP_END_MEDIUM
            },
            {
                ratio: 5,
                duration: 1,
                type: HTHWinConfig.LARGE,
                sound:HTHSound.COUNTUP_END_LARGE
            }
        ]
    }

    public static BIG_WIN_RATIOS: IBigWinRatios={
        bigWinBaseGame: [
            {
                from: 15,
                to: 25,
                id: 1,
                ratio: 15,
                duration: 3.526,
                type: HTHWinConfig.BIG_WIN_01,
                sound:HTHSound.BIGWIN[0]
            },
            {
                from: 25,
                to: 50,
                id: 2,
                ratio: 25,
                duration: 3.526,
                type: HTHWinConfig.BIG_WIN_02,
                sound:HTHSound.BIGWIN[1]
            },
            {
                from: 50,
                to: 100,
                id: 3,
                ratio: 50,
                duration: 3.526,
                type: HTHWinConfig.BIG_WIN_03,
                sound:HTHSound.BIGWIN[2]
            },
            {
                from: 100,
                to: 500,
                id: 4,
                ratio: 100,
                duration: 3.526,
                type: HTHWinConfig.BIG_WIN_04,
                sound:HTHSound.BIGWIN[3]
            },
            {
                from: 500,
                to: Number.MAX_VALUE,
                id: 5,
                ratio: 500,
                duration: 7.111,
                type: HTHWinConfig.BIG_WIN_05,
                sound:HTHSound.BIGWIN[4]
            }
        ],
        bigWinFreeSpin: [
            {
                from: 25,
                to: 50,
                id: 1,
                ratio: 25,
                duration: 3.526,
                type: HTHWinConfig.BIG_WIN_01,
                sound:HTHSound.BIGWIN[0]
            },
            {
                from: 50,
                to: 100,
                id: 2,
                ratio: 50,
                duration: 3.526,
                type: HTHWinConfig.BIG_WIN_02,
                sound:HTHSound.BIGWIN[1]
            },
            {
                from: 100,
                to: 250,
                id: 3,
                ratio: 100,
                duration: 3.526,
                type: HTHWinConfig.BIG_WIN_03,
                sound:HTHSound.BIGWIN[2]
            },
            {
                from: 250,
                to: 500,
                id: 4,
                ratio: 250,
                duration: 3.526,
                type: HTHWinConfig.BIG_WIN_04,
                sound:HTHSound.BIGWIN[3]
            },
            {
                from: 500,
                to: Number.MAX_VALUE,
                id: 5,
                ratio: 500,
                duration: 7.111,
                type: HTHWinConfig.BIG_WIN_05,
                sound:HTHSound.BIGWIN[4]
            }
        ],
        bigWinBonusBuy: [
            {
                from: 50,
                to: 100,
                id: 1,
                ratio: 50,
                duration: 3.526,
                type: HTHWinConfig.BIG_WIN_01,
                sound:HTHSound.BIGWIN[0]
            },
            {
                from: 100,
                to: 250,
                id: 2,
                ratio: 100,
                duration: 3.526,
                type: HTHWinConfig.BIG_WIN_02,
                sound:HTHSound.BIGWIN[1]
            },
            {
                from: 250,
                to: 500,
                id: 3,
                ratio: 250,
                duration: 3.526,
                type: HTHWinConfig.BIG_WIN_03,
                sound:HTHSound.BIGWIN[2]
            },
            {
                from: 500,
                to: 1000,
                id: 4,
                ratio: 500,
                duration: 3.526,
                type: HTHWinConfig.BIG_WIN_04,
                sound:HTHSound.BIGWIN[3]
            },
            {
                from: 1000,
                to: Number.MAX_VALUE,
                id: 5,
                ratio: 1000,
                duration: 7.111,
                type: HTHWinConfig.BIG_WIN_05,
                sound:HTHSound.BIGWIN[4]
            }
        ],
        bigWinGodMode: [
            {
                from: 4000,
                to: 6000,
                id: 1,
                ratio: 4000,
                duration: 3.526,
                type: HTHWinConfig.BIG_WIN_01,
                sound:HTHSound.BIGWIN[0]
            },
            {
                from: 6000,
                to: 8000,
                id: 2,
                ratio: 6000,
                duration: 3.526,
                type: HTHWinConfig.BIG_WIN_02,
                sound:HTHSound.BIGWIN[1]
            },
            {
                from: 8000,
                to: 12000,
                id: 3,
                ratio: 8000,
                duration: 3.526,
                type: HTHWinConfig.BIG_WIN_03,
                sound:HTHSound.BIGWIN[2]
            },
            {
                from: 12000,
                to: 16000,
                id: 4,
                ratio: 12000,
                duration: 3.526,
                type: HTHWinConfig.BIG_WIN_04,
                sound:HTHSound.BIGWIN[3]
            },
            {
                from: 16000,
                to: Number.MAX_VALUE,
                id: 5,
                ratio: 16000,
                duration: 7.111,
                type: HTHWinConfig.BIG_WIN_05,
                sound:HTHSound.BIGWIN[4]
            }
        ]
    }


    public static getWinConfig(providedRatio:number): IWinRatioConfig {
        const ratio: number = providedRatio;
        for (let index: number = HTHWinConfig.NORMAL_WIN_RATIOS.normalWin.length - 1; index >= 0; index--) {
            if (ratio >= HTHWinConfig.NORMAL_WIN_RATIOS.normalWin[index].ratio) {
                return HTHWinConfig.NORMAL_WIN_RATIOS.normalWin[index];
            }
        }
        return HTHWinConfig.NORMAL_WIN_RATIOS.normalWin[0];
    }

    public static getBigWinLevels(ratio: number): IBigWinLevel[] {
        let levels: IBigWinLevel[] = [];
        const length: number = HTH.model.bigWinType.length;
        for (let index: number = 0; index < length; index++) {
            if (ratio >= HTH.model.bigWinType[index].ratio) {
                levels.push(HTH.model.bigWinType[index]);

                if(HTHGameConfig.isBigWinLevel5Played){
                    if(index===3){
                        HTHGameConfig.bigWinLevelPlayed[3]=false;
                        HTHGameConfig.bigWinLevelPlayed[4]=false;
                    }
                    else if(index===4){
                        HTHGameConfig.bigWinLevelPlayed[3]=true;
                        HTHGameConfig.bigWinLevelPlayed[4]=false;
                    }
                }

            }
        }
        return levels;
    }

    public static getBigWinLevel(ratio: number): number {
        let level: number = -1;
        const length: number = HTH.model.bigWinType.length;
        for (let index: number = 0; index < length; index++) {
            if (ratio >= HTH.model.bigWinType[index].ratio) {
                level = index
            }
        }

        return level;
    }

    private static setLastConfig(winRatio: number, configs: IBigWinLevel[]): IBigWinLevel[] {
        let lastConfig = configs[configs.length - 1];
        if (lastConfig.from * 1.2 > winRatio && configs.length > 1) {
            configs.pop();
            return HTHWinConfig.setLastConfig(winRatio, configs);
        }

        lastConfig.to = winRatio;
        return configs;
    }
}
